module.exports = __webpack_public_path__ + "images/file_icons_v2/rtf-1211fc305e5da506ae859998250dbf4f.svg";